import {Fill, Stroke, Style, Text} from "ol/style";
import {importanceList} from "@/const/importance.list";

export const initializeMapRating = (map, regionRating) => {
    const layers = map.getLayers();
    let ratingSource;

    // Поиск слоя с регионами
    layers.forEach((layer) => {
        if (layer.getSource().get("name") === "map") ratingSource = layer.getSource();
    });

    if (regionRating === null) {
        clearMapRating(ratingSource);
        return false;
    }

    ratingSource.getFeatures().forEach((feature) => {
        const currentRegionRating = regionRating.find((rating) => rating.locationId === feature.get("id"));
        const colorId = currentRegionRating?.rating ? currentRegionRating.rating : 0;

        // Переписываем дефолтный стиль региона, добавляя заливку
        feature.setStyle(
            new Style({
                stroke: new Stroke({
                    color: "#585B5C",
                    width: 1
                }),
                fill: new Fill({
                    color: importanceList[colorId].mapFillColor,
                }),
                text: new Text({
                    font: "bold 12px Roboto,sans-serif",
                    fill: new Fill({ color: "#000" }),
                    text: feature.get("name")
                })
            })
        );
    });
};

const clearMapRating = (ratingSource) => {
    ratingSource.getFeatures().forEach((feature) => {
        feature.setStyle(
            new Style({
                stroke: new Stroke({
                    color: "#585B5C",
                    width: 1
                }),
                fill: new Fill({
                    color: importanceList[0].mapFillColor,
                }),
                text: new Text({
                    font: "bold 12px fangsong,sans-serif",
                    fill: new Fill({ color: "black" }),
                    text: feature.get("name")
                })
            })
        );
    });
};
